import Globe from './globe';
import Icons from './icons';

const globe = new Globe();
globe.init();

const icons = new Icons();
icons.init();